import { Card } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';

export const FullScreenCard = ({ children }: { children: ReactNode }) => (
  <div className="h-full overflow-y-hidden my-2 md:m-2 isolate">
    <Card>{children}</Card>
  </div>
);
